module.exports = __webpack_public_path__ + "img/nu.aeed3c34.svg";